import { GetAppSettings } from '../AppSettings';
import { canIUse, Features } from '../helpers/PermissionUtility';
import { isDevelopmentEnvironment } from './constants';

export function InitializeAnalytics() {
  // This just creates the stubbed out functions. No external scripts should be loaded at this point.
  // These should be called whether or not the user has tracking available.
  initializeSegment();
}

export function LoadAnalytics(isIndependentUser?: boolean) {
  const appSettings = GetAppSettings();
  if (canIUse(Features.EnableUserTracking) || isIndependentUser) {
    loadSegment(appSettings.SegmentApiKey);
  }
}

function initializeSegment() {
  try {
    const analytics = (window.analytics = window.analytics || []);
    if (!analytics.initialize)
      if (analytics.invoked) window.console && console.error && console.error('Segment snippet included twice.');
      else {
        analytics.invoked = !0;
        analytics.methods = [
          'trackSubmit',
          'trackClick',
          'trackLink',
          'trackForm',
          'pageview',
          'identify',
          'reset',
          'group',
          'track',
          'ready',
          'alias',
          'page',
          'once',
          'off',
          'on'
        ];
        analytics.factory = function (t) {
          return function () {
            // eslint-disable-next-line prefer-rest-params
            const e = Array.prototype.slice.call(arguments);
            e.unshift(t);
            analytics.push(e);
            return analytics;
          };
        };
        for (let t = 0; t < analytics.methods.length; t++) {
          const e = analytics.methods[t];
          analytics[e] = analytics.factory(e);
        }
        analytics.load = function (t) {
          const e = document.createElement('script');
          e.type = 'text/javascript';
          e.async = !0;
          e.src = ('https:' === document.location.protocol ? 'https://' : 'http://') + 'cdn.segment.com/analytics.js/v1/' + t + '/analytics.min.js';
          const n = document.getElementsByTagName('script')[0];
          n.parentNode.insertBefore(e, n);
        };
        analytics.SNIPPET_VERSION = '3.1.0';
      }
  } catch (err) {
    console.error(err);
  }
}

function loadSegment(segmentApiKey) {
  try {
    window.analytics.load(segmentApiKey);
  } catch (err) {
    console.error(err);
  }
}

export const analyticsIdentify = (id, data) => {
  try {
    if (window.analytics && window.analytics.identify) {
      window.analytics.identify(id, data);
    }
  } catch (err) {
    // ignore
    console.error(err);
  }
};

export const analyticsGroup = (id, data) => {
  try {
    // segment
    if (window.analytics && window.analytics.group) {
      window.analytics.group(id, data);
    }
  } catch (err) {
    console.error(err);
  }
};

export const analyticsPage = (route, path) => {
  try {
    // segment
    if (window.analytics && window.analytics.page) {
      const enhancedData = enhanceData();
      window.analytics.page(route, { path }, enhancedData);
    }
  } catch (err) {
    // ignore
    console.error(err);
  }
};

export const analyticsTrack = (eventName: string, data?: { [name: string]: unknown }) => {
  try {
    // segment
    if (window.analytics && window.analytics.track) {
      const enhancedData = enhanceData(data);
      window.analytics.track(eventName, enhancedData);

      if (isDevelopmentEnvironment()) {
        console.log('gf.info', 'analytics event:', eventName, data);
      }
    }
  } catch (err) {
    // ignore
    console.error(err);
  }
};

const enhanceData = (data?) => {
  const clientId = window.analytics.user?.()?.traits?.()?.usagedataid;
  const clientName = window.analytics.user?.()?.traits?.()?.clientName;
  const enhancedData = {
    source: 'Web',
    clientId: clientId,
    usagedataid: clientId, //legacy clientId
    groupId: clientId //some segment destinations only allow groupId
  };

  //adding client name so that segment can pre filter data before sending to destinations
  if (clientName) {
    enhancedData['clientName'] = clientName;
  }

  return { ...enhancedData, ...(data || {}) };
};
